// eslint-disable-next-line import/prefer-default-export
export const SELECT_TYPE_MAPPINGS: { [key: string]: string } = {
    'Region': 'region',
    'Source': 'source',
    'Metric': 'metric',
    'Active Data Source': 'active_data_source',
    'Description': 'description'
};
